import { render } from "./HospitalDashboard.vue?vue&type=template&id=7c0275ea&scoped=true"
import script from "./HospitalDashboard.vue?vue&type=script&lang=js"
export * from "./HospitalDashboard.vue?vue&type=script&lang=js"

import "./HospitalDashboard.vue?vue&type=style&index=0&id=7c0275ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0275ea"]])

export default __exports__